<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Approval Limits &nbsp;
          <add-button
            link="/procurement-management/approval-limits/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">Approval Limits</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportapproval_limits.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="approval_limits_excel"
                    :fields="excel_fields"
                    worksheet="Approval Limits"
                    name="Approval Limit.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Effective Date</th>
                    <th>Employee Role</th>
                    <th>Approval Limit Upto</th>
                    <th>Currency</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Edited Date</th>
                    <th>Edited By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="approval_limits.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(approval_limit, at) in approval_limits"
                    :key="`approval_limit${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ approval_limit.effective_date | ddmmyyyy }}</td>
                    <td>{{ approval_limit.employee_role.name }}</td>
                    <td>{{ approval_limit.approval_limit_up_to }}</td>
                    <td>{{ approval_limit.currency.name }}</td>
                    <td>{{ approval_limit.created_at | ddmmyyyy }}</td>
                    <td>{{ approval_limit.created_by.name }}</td>
                    <td>{{ approval_limit.updated_at | ddmmyyyy }}</td>
                    <td>{{ approval_limit.edited_by.name }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/procurement-management/approval-limits/${approval_limit.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(approval_limit.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";
import moment from "moment";

export default {
  name: "approvallimit",
  data() {
    return {
      approval_limits: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      approval_limits_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        "Effective Date": "effective_date",
        "Employee Role": "employee_role",
        "Approval Limit Upto": "approval_limit",
        Currency: "currency",
        "Created Date": "created_date",
        "Created By": "created_by",
        "Edited Date": "edited_date",
        "Edited By": "edited_by",
      },
      Exportapproval_limits: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let approval_limits = await axios.get(
        `/approval_limits?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.approval_limits = approval_limits.data.data;
      this.count = approval_limits.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let approval_limits = await axios.get(
        `/approval_limits?search=${this.searchData}`
      );
      this.approval_limits = approval_limits.data.data;
      this.count = approval_limits.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Approval Limit Data";
      this.approval_limits_excel = [];
      let Exportapproval_limits = [];
      Exportapproval_limits = await axios.get(`/approval_limits`);
      this.Exportapproval_limits = Exportapproval_limits.data.data;
      let sr_no = 1;
      this.Exportapproval_limits.forEach((approval_limit) => {
        this.approval_limits_excel.push({
          sr_no: sr_no,
          effective_date: approval_limit.effective_date
            ? moment(approval_limit.effective_date).format("DD-MM-YYYY")
            : "",
          employee_role: approval_limit.employee_role
            ? approval_limit.employee_role.name
            : "",
          approval_limit: approval_limit.approval_limit_up_to
            ? approval_limit.approval_limit_up_to
            : "",
          currency: approval_limit.currency ? approval_limit.currency.name : "",
          created_date: approval_limit.created_at
            ? moment(approval_limit.created_at).format("DD-MM-YYYY")
            : "",
          created_by: approval_limit.created_by
            ? approval_limit.created_by.name
            : "",
          edited_date: approval_limit.updated_at
            ? moment(approval_limit.updated_at).format("DD-MM-YYYY")
            : "",
          edited_by: approval_limit.edited_by
            ? approval_limit.edited_by.name
            : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=approval_limits`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
